import { Site } from '@snapchat/mw-common';
import { type Motif, defaultMotif } from '@snapchat/snap-design-system-marketing';

import { snapMotif } from '../brands/snap/snapMotif';
import { Config } from '../config';
import { arcadiaMotif } from '../sites/arcadia/arcadiaMotif';
import { avalonMotif } from '../sites/avalon/avalonMotif';
import { cheeriosMotif } from '../sites/cheerios/cheeriosMotif';
import { experienceMotif } from '../sites/experience/experienceMotif';
import { stinsonMotif } from '../sites/stinson/stinsonMotif';

export function getSiteMotif(): Motif | undefined {
  switch (Config.site) {
    case Site.ARCADIA:
      return arcadiaMotif;
    case Site.AVALON:
      return avalonMotif;
    case Site.CHEERIOS:
      return cheeriosMotif;
    case Site.EXPERIENCE:
      return experienceMotif;
    // Snap Brand Motifs
    case Site.CITIZEN:
    case Site.DIVERSITY:
    case Site.ENG_BLOG:
    case Site.NEWSROOM:
    case Site.SNAP:
    case Site.TRUST:
      return snapMotif;
    case Site.STINSON:
      return stinsonMotif;
    default:
      return defaultMotif;
  }
}
